/** In-app notifications + role-aware deep links. */

import { createDoc } from '../service';
import { COL } from '../../collections';
import type { NotificationDoc, Role } from '../../types';

/** Push an in-app notification to a user. */
export async function notifyUser(
  userId: string,
  data: { title: string; body?: string; type?: NotificationDoc['type']; link?: string },
) {
  return createDoc<NotificationDoc>(COL.notifications, {
    userId,
    title: data.title,
    body: data.body ?? '',
    type: data.type ?? 'info',
    link: data.link,
    read: false,
  });
}

/**
 * Role-aware deep link builder. Every app route lives under `/app/:role/…`,
 * so stored notification links must always carry the recipient's role segment.
 */
export function appLink(role: Role, path: string): string {
  const clean = path.replace(/^\/+/, '');
  return `/app/${role}/${clean}`;
}

/** Notification whose link is guaranteed to resolve for the recipient's role. */
export async function notifyRoleUser(
  userId: string,
  role: Role,
  data: { title: string; body?: string; type?: NotificationDoc['type']; link?: string },
) {
  return notifyUser(userId, {
    ...data,
    link: data.link ? appLink(role, data.link) : undefined,
  });
}
